/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Loader from '/client/src/components/Loader';
import { DELETE } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';

import EventPageVIPCodesSearchbar from './searchbar';
import EventPageDetailVIPCodesBody from './body';
import EventPageDetailVIPCodesModal from './modal';
import EventPageDetailVIPCodesURLs from './bodyUrls';

import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';

import './styles.scss';
import _ from 'lodash';

type PropsType = {
  match: {
    params: {
      tableTab?: string,
      subViewTab?: string,
      eventId: number | string
    }
  }
};

const items = [
  {
    link: 'vip-codes/codes',
    label: 'VIP codes'
  },
  {
    link: 'vip-codes/urls',
    label: 'VIP URLs'
  }
];

export const getValidTickets = (contextTickets: []): [] => { // this.context.eventDetail.tickets
  return _.filter(contextTickets, (item: {}): void => {
      let amount = 0;

      if (!isNaN(item.price)) {
        amount = amount + (+item.price);
      } else {
        return true;
      }

      if (!isNaN(item.merchant_fee)) {
        amount = amount + (+item.merchant_fee);
      }

      if (!isNaN(item.tax)) {
        amount = amount + (+item.tax);
      }

      return amount > 0;
    });
};

const EventPageDetailVIPCodes = ({ match }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);
  const contextEvent = React.useContext(EventDetailContainerContext);
  const { params: { eventId, tableTab } } = match;
  const [isOpenModal, handleToggleModal] = React.useState(false);
  const [isOpenModalFor, handleToggleModalFor] = React.useState(null);
  const [vip_codes, setDiscounts] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [selectedRows, handleSelectRow] = React.useState([]);
  const [toggledClearRows, handleToggledClearRows] = React.useState(false);
  const _tableTab = tableTab || 'codes';
  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`EventPageDetailDicountCodes-menuItems-${k}`}
        // className='active'
        className={`${(_tableTab ? _tableTab.toLowerCase() : '') === i.link.split('/')[1] ? 'active' : ''}`}
      >
        <Link to={`/events/${eventId}/manage/${i.link}`}>
          {i.label}
        </Link>
      </li>
    );
  });
  const isReadOnly = contextEvent.eventDetail.permission === 'Read';

  const handleLoaded = React.useCallback(
    async (error: Error, response: any) => {
      if (!error) {
        try {
          setDiscounts(_.get(response, 'data.result.items', []));
          setIsLoaded(true);
        } catch (e) {
          console.error('Can\'t get VIP codes list');
        }
      }
    },
    []
  );

  const handleRemoveVIPGroup = async (): any => {
    if (!_.size(selectedRows)) {
      return;
    }

    CssPinner(document.querySelector('.EventDetailContainer .panel-body'), true);

    const removedGroupIds = _.map(selectedRows, (sr: {}): number => sr.group_id);

    try {
      // TODO change to VIP endpoint
      await DELETE(`/api/v1/1/vipcodes/${eventId}`, {
        group_ids: removedGroupIds
      });

      const discountsUpdate = _.compact(_.map(vip_codes, (d: {}): any => {
        if (_.indexOf(removedGroupIds, d.group_id) < 0) {
          return d;
        }
      }));

      handleSelectRow([]);
      handleToggledClearRows(!toggledClearRows);
      setDiscounts(discountsUpdate);

      CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
    } catch (e) {
      CssPinner(document.querySelector('.EventDetailContainer .panel-body'), false);
    }
  };

  const handleAddVipcode = (data: {}, status: string | boolean) => {
    const row = data[0];

    row.codes = _.map(data, (d: {}): {} => d.coupon_code);

    if (status === 'add') {
      const _applied_to_tickets = [];

      _.forEach(data[0].applied_to_ticket_id, (i: string) => {
        const current = _.find(contextEvent.eventDetail.tickets, ['id', i ]);

        _applied_to_tickets.push(current.name);
      });


      row.applied_to_tickets = _applied_to_tickets;

      if (!row.is_enable_expiration) {
        setDiscounts([
          ...vip_codes,
          {
            ...row,
            begin_time_utc: null,
            end_time_utc: null
          }
        ]);
      } else {
        setDiscounts([
          ...vip_codes,
          row
        ]);
      }
    } else {
      handleUpdateDiscount(row);
    }
  };

  const handleUpdateDiscount = (_d: {}) => {
    const updatedDiscounts = _.filter(vip_codes, (d: {}): boolean => {
      return d.group_id !== _d.group_id;
    });

    if (!_d.is_enable_expiration) {
      updatedDiscounts.push({
        ..._d,
        begin_time_utc: null,
        end_time_utc: null
      });
    } else {
      updatedDiscounts.push(_d);
    }

    handleSelectRow([]);
    handleToggledClearRows(!toggledClearRows);
    setDiscounts(updatedDiscounts);
  };

  return (
    <div className="panel panel-default EventPageDetailDicountCodes">
      <div className="navbar-page-toolbar customers-navbar resend-navbar">
        <div className="container-fluid" style={{ height: '50px' }}>
          <ul className="nav top-nav hidden-520">
            {menuItems}
          </ul>

          <ul className="nav">
            <li className="dropdown hide show-520">
              <a href="#"
                className="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="icon icon-bars" />
              </a>
              <ul className="dropdown-menu">
                {menuItems}
              </ul>
            </li>
          </ul>
        </div>

        {_tableTab && _tableTab.toLowerCase() !== 'urls' && isLoaded &&
          <EventPageVIPCodesSearchbar
            eventId={eventId}
            handleShowModal={handleToggleModal}
            isOpenModalFor={isOpenModalFor}
            handleToggleModalFor={handleToggleModalFor}
            selectedRows={selectedRows}
            handleRemoveVIPGroup={handleRemoveVIPGroup}
            handleSelectRow={handleSelectRow}
            handleToggledClearRows={handleToggledClearRows}
            toggledClearRows={toggledClearRows}
            contextEvent={contextEvent}
            isReadOnly={isReadOnly}
          />
        }
      </div>

      {_tableTab && _tableTab.toLowerCase() !== 'urls' ?
        <>
          <Loader
            url={`/api/v1/1/vipcodes/${eventId}`}
            onLoaded={handleLoaded}
          >
            {!!_.size(vip_codes) ?
              <EventPageDetailVIPCodesBody
                vip_codes={vip_codes}
                toggledClearRows={toggledClearRows}
                handleSelectRow={(tableState: {}) => {
                  handleSelectRow(tableState.selectedRows);
                  handleToggledClearRows(toggledClearRows);
                }}
                eventId={eventId}
                isReadOnly={isReadOnly}
              /> : <div className='panel-body'>
                VIP Codes not found
              </div>}
          </Loader>

          {isOpenModal &&
            <EventPageDetailVIPCodesModal
              isOpen={isOpenModal}
              handleShowModal={handleToggleModal}
              handleAddVipcode={handleAddVipcode}
              isOpenModalFor={isOpenModalFor}
              vip_codes={vip_codes}
              selectedRow={selectedRows[0]}
              eventId={eventId}
              defaultContainerContext={context}
            />
          }
        </> :
        <EventPageDetailVIPCodesURLs eventId={eventId} />
      }
    </div>
  );
};

export default withRouter(EventPageDetailVIPCodes);
